import React from "react";
import RegsugarService from "../../services/regsugar.service";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function DownloadPDF(prop) {
  function downloadPDF(id, idno) {
    RegsugarService.downloadPdf(id)
      .then((resp) => {
        const pdfLink = `data:application/pdf;base64,${resp.data.data}`;
        const anchorElement = document.createElement("a");
        const fileName = `${idno}.pdf`;
        anchorElement.src = pdfLink;
        anchorElement.href = pdfLink;
        anchorElement.target = "_blank";
        anchorElement.download = fileName;
        anchorElement.rel = "noreferrer";
        anchorElement.click();
      })
      .catch((err) => alert(err.response.data.message));
  }

  const renderTooltip = (props) => {
    return <Tooltip {...props}>คลิ๊กเพื่อดาวน์โหลดบัตรชาวไร่</Tooltip>;
  };
  return (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      <a
        style={{ textDecoration: "underline" }}
        onClick={() => downloadPDF(prop.card, prop.idno)}
      >
        {prop.idno}
      </a>
    </OverlayTrigger>
  );
}

export default DownloadPDF;
